import Vue from 'vue'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import '@/styles/index.styl'

import App from './App'
// import store from './store'
import router from './router'

import './directive';
import './icons' // icon

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  // store,
  render: h => h(App)
})

// if (process.env.NODE_ENV !== 'development') {
//   import('./lib/utils/sentry-reporter');
// }
